import React from 'react'
import { Stack, Text, Textarea, Group } from 'components'
import { useTranslation } from 'react-i18next'

interface ProjectDescriptionSectionProps {
  value: string
  onChange: (value: string) => void
  error?: boolean
}

export const ProjectDescriptionSection: React.FC<ProjectDescriptionSectionProps> = ({
  value,
  onChange,
  error
}) => {
  const { t } = useTranslation()

  return (
    <Stack spacing="md">
      <div>
        <Group spacing="xs" mb="0">
          <Text size="lg" weight={500}>
            {t('arc_project_what_about')}
            <Text color="red" display="inline"> *</Text>
          </Text>
        </Group>
        <Text size="lg" color="dimmed" mb="sm">
          {t('arc_project_describe_idea')}
        </Text>
        <Textarea
          size="md"
          placeholder={t('arc_project_description_placeholder')}
          value={value}
          onChange={(e) => onChange(e.currentTarget.value)}
          minRows={3}
          required
          error={error}
        />
        {error && (
          <Text size="sm" color="red" mt={4}>
            {t('arc_field_required')}
          </Text>
        )}
      </div>
    </Stack>
  )
}